import { render, staticRenderFns } from "./BindingMobile.vue?vue&type=template&id=7988deaa&"
import script from "./BindingMobile.vue?vue&type=script&lang=js&"
export * from "./BindingMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports